/**
=========================================================
* Argon Dashboard 2 MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-material-ui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
 


import Card from "@mui/material/Card";

// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";

// Argon Dashboard 2 MUI examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Grid from "@mui/material/Grid";
import ArgonInput from "components/ArgonInput";

// Data
import TestUserTableData from "Views/TestUser/data/TestUserTableData"
import { useState,useEffect } from "react";
import ArgonButton from "components/ArgonButton";
import DeleteDialog from "components/DeleteDialog/DeleteDialog";

function Tables() {
 
  const[DeleteOpen,setDeleteOpen] = useState(false);

  const handleDeleteClick = () => {
    setDeleteOpen(true);
  };

  const handleDeleteClose = () => {
    setDeleteOpen(false);
  }

  const { columns, rows } = TestUserTableData(handleDeleteClick);
  const[open,setopen] = useState(false)
  const handleOpen = () => setopen(true);
  const handleClose = () => setopen(false);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <ArgonBox py={3}>
        <ArgonBox mb={3}>
          <Card>
            <ArgonBox  p={3} display="flex" justifyContent="space-between" alignItems="center">
              <ArgonTypography mb={2}  variant="h6" fontWeight="medium">Test User</ArgonTypography>
               <ArgonButton size="small" onClick={handleOpen} variant="contained" color="primary">Add</ArgonButton>
            </ArgonBox>
            <ArgonBox
              sx={{
                "& .MuiTableRow-root:not(:last-child)": {
                  "& td": {
                    borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                      `${borderWidth[1]} solid ${borderColor}`,
                  },
                },
              }}
            >
              <Table columns={columns} rows={rows} />
            </ArgonBox>
          </Card>
        </ArgonBox>

         <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      {/* Header */}
      <DialogTitle>
        <ArgonTypography variant="h5" fontWeight="bold" color="dark">
          Add Mobile Number
        </ArgonTypography>
      </DialogTitle>

      {/* Body */}
      <DialogContent>
        <ArgonBox py={2}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <ArgonInput
                fullWidth
                type="text"
                placeholder="Enter Mobile Number"
                label="Mobile Number"
              />
            </Grid>
          </Grid>

          {/* Footer Buttons */}
          <ArgonBox display="flex" justifyContent="space-between" mt={4}>
            <ArgonButton variant="outlined" color="secondary" onClick={handleClose}>
              Cancel
            </ArgonButton>
            <ArgonButton
              variant="gradient"
              color="info"
              sx={{ backgroundColor: "rgb(8, 2, 120)" }}
            >
              Save
            </ArgonButton>
          </ArgonBox>
        </ArgonBox>
      </DialogContent>
    </Dialog>
        

      </ArgonBox>

      <DeleteDialog
        open={DeleteOpen}
        onClose={handleDeleteClose}
        title="Are you sure you want to delete this Test User?"
        description="This action cannot be undone."
        cancelText="Cancel"
        confirmText="Delete"
      />
      <Footer />
    </DashboardLayout>
  );
}

export default Tables;
